class ServiceInsuranceMapper {
  static createFromResponse(response) {
    return {
      base: parseFloat(response.base_insurance),
      max: parseFloat(response.max_insurance),
      additionalInsurance: response.additional_insurance
    };
  }
  static createIntFromResponse(response) {
    return {
      base: parseInt(response.base_insurance, 10),
      max: parseInt(response.max_insurance, 10),
      additionalInsurance: response.additional_insurance
    };
  }
}

export { ServiceInsuranceMapper };
//# sourceMappingURL=ServiceInsuranceMapper.js.map
